/* eslint-disable */
import { useRef, useState } from 'react';
const SpeechSDK = window.SpeechSDK;

export interface SpeechText {
  st: number;
  text: string;
  lang: string;
  recognizing: boolean;
}

export const useSpeechRecognition = (
  autoDetectSourceLanguage: string[] = ['en-US', 'ja-JP', 'zh-CN', 'ko-KR', 'vi-VN'],
  token: string,
  onRecognizing: (data: SpeechText) => void,
  onRecognized: (data: SpeechText) => void,
  onStop?: (data: SpeechText) => void
) => {
  const recognizerRef = useRef<any>(null);
  const [startState, setStartState] = useState(false);
  const intervalRef = useRef<any>(null);
  const [speechText, setSpeechText] = useState<SpeechText>({
    st: Date.now(),
    text: '',
    lang: '',
    recognizing: true,
  });
  const startInit = async (_token: string, _lang?: string[]) => {
    setSpeechText({
      st: Date.now(),
      text: '',
      lang: '',
      recognizing: true,
    });
    const transferLang = _lang?.map((lang) => {
      if (lang === 'ja') return 'ja-JP';
      if (lang === 'zh') return 'zh-CN';
      if (lang === 'ko') return 'ko-KR';
      if (lang === 'en') return 'en-US';
      return lang;
    });

    const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(_token, 'japaneast');
    speechConfig.setProperty('SpeechServiceResponse_PostProcessingOption', 'TrueText');
    var audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    // 发现日语偶尔会被识别成比如说韩语，日本同事反馈了，那么就只测试日语吧。
    const autoDetectSourceLanguageConfig = SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(
      _lang ? transferLang : autoDetectSourceLanguage
    );
    autoDetectSourceLanguageConfig.mode = SpeechSDK.LanguageIdMode.Continuous;
    const recognizer = SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);

    const words = [
      'Sparticle',
      'GBase',
      'GBase Support',
      'GBase Knowledge',
      'Felo Subtitles',
      'GB-Chan',
      'ジービーちゃん',
      '吉比酱',
    ];

    const phraseList = SpeechSDK.PhraseListGrammar.fromRecognizer(recognizer);
    words.forEach((word) => {
      phraseList.addPhrase(word);
    });

    console.log('phraseList', phraseList);
    recognizer.recognizing = (_s: any, e: any) => {
      console.log(`@@speech>>RECOGNIZING: Text=${e.result.text},  id=${e.result.resultId}`);
      const speechText = { text: e.result.text, recognizing: true, lang: e.result.language, st: Date.now() };
      setSpeechText(speechText);

      onRecognizing(speechText);
    };

    recognizer.recognized = (_s: any, e: any) => {
      console.log(`@@speech>>RECOGNIZED: Text=${e.result.text},  id=${e.result.resultId}`);
      const text = e.result.text;
      if (!text) return;
      if (typeof text === 'string' && !text.trim()) return;

      const speechText = {
        text: e.result.text,
        recognizing: false,
        lang: e.result.language,
        st: Date.now(),
      };
      setSpeechText(speechText);
      onRecognized(speechText);
    };

    recognizer.canceled = (_s: any, e: any) => {
      console.log(`##speech CANCELED: Reason=${e.reason}`);
      stop();
      close();
      startInit(token);
    };
    recognizer.sessionStopped = (_s: any, e: any) => {
      console.log('##speech Session stopped.', e.sessionId);
      onStop && onStop(speechText);
    };
    recognizerRef.current = recognizer;
    return;
  };
  const startSpeak = () => {
    setSpeechText({
      st: Date.now(),
      text: '',
      lang: '',
      recognizing: false,
    });
    try {
      if (recognizerRef.current)
        recognizerRef.current.startContinuousRecognitionAsync(
          () => {
            console.log('Recognition started.');
            setStartState(true);
          },
          (err: any) => {
            console.error(`Failed to start recognition: ${err}`);
            setStartState(false);
          }
        );
    } catch (e) {
      console.log(e);
      setStartState(false);
    }
  };
  const stop = async () => {
    try {
      if (recognizerRef.current) {
        recognizerRef.current.stopContinuousRecognitionAsync(
          () => {
            setStartState(false);
          },
          (err: any) => {
            console.error(`Failed to stop recognition: ${err}`);
            setStartState(false);
          }
        );
      }
    } catch (e) {
      console.log(e);
      setStartState(false);
    }
  };
  const close = () => {
    clearInterval(intervalRef.current);
    if (recognizerRef.current) recognizerRef.current.close();
    recognizerRef.current = null;
  };
  return {
    startInit,
    stop,
    speechText,
    startState,
    startSpeak,
  };
};
